import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

// Choice surface chrome (`choice`, `choice--selected`, etc.) belongs to <ButtonChoice> in ButtonChoice.styles.ts — a rule here would be dead CSS, since no element in this component carries those classes.
export default createUseStyles({
    choiceHeader: {
        composes: "choice__header",
        fontWeight: 700,
        margin: ({ theme }) => [[Mixins.getSpacing(theme, theme.ChoiceSpacing, theme.QuestionSpacing?.WithinComponents), 0]],
    },
    choiceContainer: {
        alignItems: "center",
        composes: "choice-container",
        display: "flex",
        flex: 1,
        flexDirection: ({ theme }) => (theme.DisplayChoiceIcon === "right" ? "row-reverse" : "row"),
        "& .check-box__icon": {
            flexDirection: ({ theme }) =>
                theme.CheckBoxIconAlignment === "right" ? "row-reverse" : "row",
        },
        "& .radio__icon": {
            flexDirection: ({ theme }) =>
                theme.RadioIconAlignment === "right" ? "row-reverse" : "row",
        },
    },
});
